import { DuplicatePromotionChallengePage } from './DuplicatePromotionChallengePage'
import { withDuplicatePromotionChallengePage } from './withDuplicatePromotionChallengePage'

const Connected = withDuplicatePromotionChallengePage(
  DuplicatePromotionChallengePage
)

export { Connected as DuplicatePromotionChallengePage }
